export const shuffleArray = <T>(array: T[]): T[] => {
  const shuffledArray = [...array];
  for (let i = shuffledArray.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [shuffledArray[i], shuffledArray[j]] = [shuffledArray[j], shuffledArray[i]];
  }
  return shuffledArray;
};

export const arrayRange = (start, stop, step) =>
  Array.from(
    { length: (stop - start) / step + 1 },
    (value, index) => start + index * step
  );

export const arrayToObject = (list, key = 'id'): Object => {
  return list.reduce((acc, cur) => {
    const k = cur[key];
    acc[k] = cur;
    return acc;
  }, {});
};

export const enumToValues = (enumObj: any): string[] => {
  return Object.values(enumObj) as string[];
};

export const getRandomElement = <T>(arr: T[]): T => {
  return arr[Math.floor(Math.random() * arr.length)];
};
